import { CollapseImageInterface } from '../../../Interfaces/CollapseInterface'
import { Icon } from '../../Elements'
import Avatar from '../ImageAvatars/Avatar'

const CollapseImage = ({
  onClick,
  keyItem,
  title,
  className,
  element,
  url,
  index,
}: CollapseImageInterface) => {
  return (
    <>
      <div
        className={`flex flex-col justify-center items-center w-full  `}
      >
        <div
          onClick={() => {
            onClick?.(keyItem)
          }}
          className={`  ${className?.className ?? ''
            }  flex justify-between items-center bg-white relative p-2 w-full ${index ? 'ring-1 shadow-inner' : ''
            }`}
        >
          <div className='flex gap-3 justify-center items-center'>
            <Avatar
              className={`!h-12 !w-12 ${className?.imageClass ?? ''}`}
              url={url}
            />
            <span className={`${className?.titleClass ?? ''} text-sm`}>
              {title}
            </span>
          </div>

          <Icon
            icon={'rayteb-arrow-1-down'}
            className={` text-xs  ${index ? 'duration-300 rotate-180' : 'duration-300 rotate-0'
              }`}
          />
        </div>
        <div className={`   w-full ${index ? 'block' : 'hidden'}`}>
          {element}
        </div>
      </div>
    </>
  )
}

export default CollapseImage
